import { createFileRoute } from "@tanstack/react-router";

import { AgencyPackagePage } from "@/components/agency-package-page";
import { FNM_PAYMENT_DESCRIPTION } from "@/lib/agency-packages";

// Private QR-only landing page: noindex and not in the sitemap.
const AGENCY = "First National Moreton";

export const Route = createFileRoute("/first-national-moreton")({
  head: () => ({
    meta: [
      { title: `${AGENCY} sellers | AML and Form 2 package | Coastside Law` },
      {
        name: "description",
        content: `AML identity checks and a solicitor-prepared Form 2 for ${AGENCY} sellers: $799 all inclusive. ${FNM_PAYMENT_DESCRIPTION}`,
      },
      { property: "og:title", content: `${AGENCY} sellers | Coastside Law` },
      { property: "og:description", content: `AML and Form 2: $799 all inclusive. ${FNM_PAYMENT_DESCRIPTION}` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <AgencyPackagePage agency={AGENCY} paymentDescription={FNM_PAYMENT_DESCRIPTION} />,
});
